import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CommonConstants } from 'src/app/common/utilities/commonConstants';
import { RouteHandlerService } from '../../common/services/routeHandler.service';
import { PaymentStatusService } from '../../paymentReview/paymentStatus.service';
import { Formatter } from '../../common/services/formatter';
import { SessionHandlerService } from '../../common/services/sessionHandler.service';
import { CongratulationsService } from '../congratulations/congratulations.service';
import { PlanDetailsService } from 'src/app/common/services/planDetails.service';
// import { PlanDetailsService } from 'src/app/applicationModule/planDetail/planDetails.service';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/common/services/google_analytics.service';
import { adobe_analytics_service } from '../../common/services/adobe_analytics_service';
import { SharedService } from '../../common/services/sharedService';
import { RouteContextProvider } from 'src/app/common/services/routeContextProvider.service';
import { environment } from 'src/environments/environment';
import { PaymentService } from 'src/app/payment/payment.service';

const banners = [
  {
    "aemImageUrl": 'https://bfsd.uat.bfsgodirect.com/content/dam/bajajfinserv/insurance/assetinsurance-solutions/transaction_success_banners/MotorInsurance%204W.png',
    "redirectUrl": 'https://www.bajajfinserv.in/marketplace/insurance/car-insurance/car-insurance-premium-calculator/vehicleRegistration?utm_source=Trans-page&utm_medium=banner&utm_campaign=Car',
    "redirectionKey": 'INSCATEGORY',
    "redirectionValue": 'MOTOR'
  },
  {
    "aemImageUrl": 'https://bfsd.uat.bfsgodirect.com/content/dam/bajajfinserv/insurance/assetinsurance-solutions/transaction_success_banners/MotorInsurance2W.png',
    "redirectUrl": 'https://www.bajajfinserv.in/marketplace/insurance/two-wheeler-insurance/bike-insurance-premium-calculator/vehicleRegistration?utm_source=Trans-page&utm_medium=banner&utm_campaign=bike',
    "redirectionKey": 'INSCATEGORY',
    "redirectionValue": 'BIKE'
  },
  {
    "aemImageUrl": 'https://bfsd.uat.bfsgodirect.com/content/dam/bajajfinserv/insurance/assetinsurance-solutions/transaction_success_banners/HealthInsurance.png',
    "redirectUrl": 'https://www.bajajfinserv.in/marketplace/insurance/health-insurance/health-insurance-premium-calculator/getGoingNow?utm_source=Trans-page&utm_medium=banner&utm_campaign=health',
    "redirectionKey": 'INSCATEGORY',
    "redirectionValue": 'HEALTH'
  },
  {
    "aemImageUrl": 'https://bfsd.uat.bfsgodirect.com/content/dam/bajajfinserv/insurance/assetinsurance-solutions/transaction_success_banners/AssetInsurance.png',
    "redirectUrl": 'https://www.bajajfinserv.in/marketplace/insurance/extended-warranty/premium-calculator/getGoingNow?utm_source=Trans-page&utm_medium=banner&utm_campaign=Asset',
    "redirectionKey": 'INSCATEGORY',
    "redirectionValue": 'ASSET'
  }
]
declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean
  }
}

@Component({
  selector: 'app-congratulations-component',
  templateUrl: './congratulations.template.html',
  styleUrls: ['./congratulations.style.scss'],
  providers: [PaymentStatusService, CongratulationsService]
})
export class CongratulationsComponent implements OnInit {
  public isReadOnly = false;
  public rate;
  public principalCode: string;
  public currentTaskKey: string;
  public PaymentData: any;
  // public PaymentDetails: any = null;
  public showLoader = true;
  public policyDownloadResponseList: any;
  public CongratulationScreen = false;
  public PolicyNum = null;
  public exploreUrl = 'https://www.bajajfinservmarkets.in/';
  public exploreUrlBFL = 'https://www.bajajfinserv.in/insurance?utm_source=insurancemarketplace&utm_medium=health&utm_campaign=thankyoupage&utm_content=paymentsuccess&utm_term=';
  public bothPoliciesNull = false;
  public resultArray: any;
  public policyNullCheck: any;
  // public summaryData;
  public quoteDetail;
  public paymentDetail;
  public aemFragmentInfo: any;
  public quoteItemDetail: any;
  public planCode: any;
  public isPartnerLogoLoaded = false;
  public selectedSumAssured;
  public totalGrossPremium;
  public cashlessHospitalcount = 0;
  public variantCode;
  public principalId;
  public selectedSumAssuredAddOn;
  public quoteItemDetailAddon: any;
  bflJourney: any;
  isMobileFlag: string;
  applicationId;
  quoteId;
  count = 0;
  stagePercentage: any;
  pinCode: any;
  cityName: any;
  morethan30: boolean;
  setTimerCall: any;
  limitCross: boolean = false;
  isResumeJoureny: any;
  public disclaimer_msg: any;

  @Input() timeDifference: any = 15000;
  @Input() summaryData: any;
  @Input() PaymentDetails: any;
  public finalBannerAemArray = [];

  paymentId: any;
  // finalBannerAemArray: {
  //   "aemImageUrl": string; "redirectUrl": string; //www.bajajfinserv.in/';
  //   "redirectionKey": string; "redirectionValue": string;
  // }[];

  loanAccountNumber: any;
  fundingAmount: any;
  fundingTenor: any;
  firstEmiDate: any;
  // Constructor
  constructor(
    public formatter: Formatter,
    private _routerService: RouteHandlerService,
    private paymentStatusService: PaymentStatusService,
    private _sessionHandlerService: SessionHandlerService,
    private _CongratulationsService: CongratulationsService,
    private _planDetailsService: PlanDetailsService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    public router: Router,
    private _adobe_analytics_service: adobe_analytics_service,
    private sharedService: SharedService,
    private _routeContextProvider: RouteContextProvider,
    private _paymentService: PaymentService
  ) { }

  // On init
  ngOnChanges(changes: SimpleChanges) {
    console.log(this.timeDifference);
  }
  public ngOnInit() {
    this.bflJourney = this.sharedService.isBFLJourney();
    this.setBannersAccordingEnviorment();
    this.disclaimer_msg = CommonConstants.DISCLAIMER_TEXT;
    console.log(this.timeDifference);
    // console.log(20000 - this.timeDifference);
    let resumej = this._routeContextProvider.GetQueryParams('sessionId');
    let currenturl = this.router.url;
    console.log((currenturl).split('?')[0])
    console.log(((((currenturl).split('?')[0]) !== '/congratulations')))
    this.isResumeJoureny = (resumej == null || resumej == undefined || resumej == '') ? false : true;
    if ((((currenturl).split('?')[0]) === '/congratulations')) {
      this.isResumeJoureny = true;
    }
    this.showLoader = true;
    console.log(this.isResumeJoureny)
    if (this.isResumeJoureny == true && this.summaryData == undefined) {
      this.setTimerCall = 25000;
    } else {
      this.setTimerCall = (20000 - this.timeDifference) > 0 ? 20000 - this.timeDifference : 0;
    }

    this.router.navigateByUrl(location.href, { replaceUrl: true });
    const mainContainerHeight = document.getElementById('main-app-container').style.minHeight = '80vh';
    this.currentTaskKey = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR);
    this.principalCode = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.principalCode);
    this.variantCode = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.variantCode);
    this.applicationId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId);
    this.quoteId = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId);
    this.cityName = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.cityName);
    this.getContentFragment();
    if (this.PaymentDetails == undefined) {
      this.getPaymentStatus();
    }
    console.log(this.summaryData);
    if (this.summaryData == undefined) {
      this.getSummaryDetails();
    } else {
      this.planDetialsFromStatusCall();
    }

    // this.getSummaryDetails();

    // if (this.currentTaskKey.toLowerCase() === 'inspolicypage') {
    //   // this.getPaymentStatus();
    //   this.getSummaryDetails((resp) => {
    //     this.quoteItemDetail = resp.quoteItemDetail.find(element => element.quoteItemType === "PRIMARY");
    //     this.quoteItemDetailAddon = resp.quoteItemDetail.find(element => element.quoteItemType === "ADDON");
    //     this.planCode = resp.quoteDetail.productCode;
    //     this.principalCode = resp.quoteDetail.principalCode;
    //     const data = {
    //       urlData: {
    //         applicationId: resp.quoteDetail.applicationId,
    //         quoteId: resp.quoteDetail.quotekey
    //       },
    //       payload: null
    //     };
    //     this.policyPostCall(data);
    //   });
    // } else {
    //   // this.getPaymentStatus();
    //   this.getSummaryDetails((resp) => {
    //     this.quoteItemDetail = resp.quoteItemDetail.find(element => element.quoteItemType === "PRIMARY");
    //     this.quoteItemDetailAddon = resp.quoteItemDetail.find(element => element.quoteItemType === "ADDON");

    //     this.planCode = resp.quoteDetail.productCode;
    //   });

    // }


  }
  planDetialsFromStatusCall() {
    this.quoteDetail = this.summaryData.quoteDetail;
    this.paymentDetail = this.summaryData.paymentDetail;
    this.principalCode = this.quoteDetail.principalCode;
    this.planCode = this.quoteDetail.productCode;
    this.principalId = this.quoteDetail.principalId;
    this.totalGrossPremium = this.summaryData.quoteDetail.grossPremiumAmount;
    this.quoteItemDetail = this.summaryData['quoteItemDetail'];
    this.variantCode = this.quoteItemDetail && this.quoteItemDetail[0] && this.quoteItemDetail[0].productVariantCode;
    this.pinCode = this.summaryData.pinCode;
    this.stagePercentage = this.summaryData.applicationStageResponse.appStagePercentage;
    this.loanAccountNumber = this.paymentDetail.loanAccountNumber;
    this.fundingAmount = this.paymentDetail.fundingAmount;
    this.fundingTenor = this.paymentDetail.fundingTenor;
    this.firstEmiDate = this.paymentDetail.firstEmiDate.split('-').reverse().join('-');
    if (!!this.summaryData.cashlessHospital && !!this.summaryData.cashlessHospital.cashlessHospitalList) {
      const cashlessHospitalObj =
        this.summaryData.cashlessHospital.cashlessHospitalList.filter(val => val.principalId === this.principalId);

      this.cashlessHospitalcount = cashlessHospitalObj.length > 0 ? cashlessHospitalObj[0].hospitalCount : 0;
    } else {
      this.cashlessHospitalcount = 0;
    }
    let clonequoteItemDetail = this.quoteItemDetail

    clonequoteItemDetail.forEach(ele => {
      if (ele.quoteItemType === 'ADDON') {
        this.selectedSumAssuredAddOn = ele.sumassuredamt;
      } else if (ele.quoteItemType === 'PRIMARY') {
        this.selectedSumAssured = ele.sumassuredamt;
      }
    });
    this.quoteItemDetail = this.quoteItemDetail.find(element => element.quoteItemType === "PRIMARY");
    this.quoteItemDetailAddon = clonequoteItemDetail?.find(element => element?.quoteItemType === "ADDON");
    if (this.setTimerCall == 0) {
      this.showLoader = false;
      this.morethan30 = true;
      return;
    }
    setTimeout(() => {
      this.showLoader = false;
      console.log('1')
      if (!(this.CongratulationScreen && this.policyDownloadResponseList)) {
        this.morethan30 = true;
        console.log(new Date().getTime())
      } else {
        this.limitCross = true;
      }
    }, this.setTimerCall);

    if (this.currentTaskKey.toLowerCase() === 'inspolicypage') {
      this.planCode = this.quoteDetail.productCode;
      this.principalCode = this.quoteDetail.principalCode;
      const data = {
        urlData: {
          applicationId: this.quoteDetail.applicationId,
          quoteId: this.quoteDetail.quotekey
        },
        payload: null
      };
      this.policyPostCall(data);
    }
    this.googleAnalyticRetry();
  }


  public getSummaryDetails() {
    this._CongratulationsService.showSummary().subscribe((response: ActivitiModel.MTResponse<any>) => {
      if (!response.errors) {
        if (response.payload) {
          this.summaryData = response.payload;
          this.quoteDetail = this.summaryData.quoteDetail;
          this.paymentDetail = this.summaryData.paymentDetail;
          this.paymentId = this.paymentDetail.paymentId;
          this.principalCode = this.quoteDetail.principalCode;
          this.planCode = this.quoteDetail.productCode;
          this.principalId = this.quoteDetail.principalId;
          this.totalGrossPremium = this.summaryData.quoteDetail.grossPremiumAmount;
          this.quoteItemDetail = this.summaryData['quoteItemDetail'];
          this.variantCode = this.quoteItemDetail && this.quoteItemDetail[0] && this.quoteItemDetail[0].productVariantCode;
          this.pinCode = this.summaryData.pinCode;
          this.stagePercentage = this.summaryData.applicationStageResponse.appStagePercentage;
          this.loanAccountNumber = this.paymentDetail.loanAccountNumber;
          this.fundingAmount = this.paymentDetail.fundingAmount;
          this.fundingTenor = this.paymentDetail.fundingTenor;
          this.firstEmiDate = this.paymentDetail.firstEmiDate && this.paymentDetail.firstEmiDate.split('-').reverse().join('-');
          if (!!this.summaryData.cashlessHospital && !!this.summaryData.cashlessHospital.cashlessHospitalList) {
            const cashlessHospitalObj =
              this.summaryData.cashlessHospital.cashlessHospitalList.filter(val => val.principalId === this.principalId);

            this.cashlessHospitalcount = cashlessHospitalObj.length > 0 ? cashlessHospitalObj[0].hospitalCount : 0;
          } else {
            this.cashlessHospitalcount = 0;
          }
          let clonequoteItemDetail = this.quoteItemDetail
          clonequoteItemDetail.map(ele => {
            if (ele.quoteItemType === 'ADDON') {
              this.selectedSumAssuredAddOn = ele.sumassuredamt;
            } else if (ele.quoteItemType === 'PRIMARY') {
              this.selectedSumAssured = ele.sumassuredamt;
            }
          });
          this.quoteItemDetail = this.quoteItemDetail.find(element => element.quoteItemType === "PRIMARY");
          this.quoteItemDetailAddon = clonequoteItemDetail?.find(element => element?.quoteItemType === "ADDON");
          if (this.setTimerCall == 0) {
            console.log('2')
            this.showLoader = false;
            this.morethan30 = true;
            return;
          }
          setTimeout(() => {
            console.log('3')
            this.showLoader = false;
            console.log(this.setTimerCall);
            if (!(this.CongratulationScreen && this.policyDownloadResponseList)) {
              this.morethan30 = true;
              console.log('4')
              console.log(this.setTimerCall)
              console.log(new Date().getTime())
            } else {
              console.log('5')
              this.limitCross = true;

            }
          }, this.setTimerCall);

          if (this.currentTaskKey.toLowerCase() === 'inspolicypage') {
            this.planCode = this.quoteDetail.productCode;
            this.principalCode = this.quoteDetail.principalCode;
            const data = {
              urlData: {
                applicationId: this.quoteDetail.applicationId,
                quoteId: this.quoteDetail.quotekey
              },
              payload: null
            };
            this.policyPostCall(data);
          }
          this.googleAnalyticRetry();
        }
      }
    });
  }

  private base64ToArrayBuffer(data) {
    let binaryString = window.atob(data);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  //for mobile device fix
  private downloadDocument(data) {
    const contentType = 'application/pdf';
    let fileObj = new Blob([this.base64ToArrayBuffer(data)], { type: contentType });
    const filename = 'policy_document.pdf';
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      window.navigator.msSaveBlob(fileObj, filename);
      return;
    }
    const blobURL = window.URL.createObjectURL(fileObj);
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    tempLink.setAttribute('download', filename);
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank');
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    setTimeout(() => {
      window.URL.revokeObjectURL(blobURL);
    }, 100);
  }

  // Downloading Policy
  public DownloadPolicy(data) {
    if (data.fileUrl) {
      var prefix = 'http://';
      var sprefix = 'https://';
      if ((data.fileUrl.substr(0, prefix.length) !== prefix) && (data.fileUrl.substr(0, sprefix.length) !== sprefix)) {
        data.fileUrl = sprefix + data.fileUrl;
      }
      window.open(data.fileUrl);
    } else if (data.fileData) {
      const platform = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.platform);
      if ((platform.toLowerCase() === CommonConstants.platforms.ios) || (platform.toLowerCase() === CommonConstants.platforms.android)) {
        this.downloadDocument(data.fileData);
      } else {
        let newPdfWindow = window.open("", "Print");
        let content = encodeURIComponent(data.fileData);
        let iframeStart = "<\iframe width='100%' height='100%' src='data:application/pdf;base64, ";
        let iframeEnd = "'><\/iframe>";
        newPdfWindow.document.write(iframeStart + content + iframeEnd);
        var link = document.createElement('a');
        link.innerHTML = 'Download PDF file';
        link.download = data.policyNumber + '.pdf';
        link.href = 'data:application/octet-stream;base64,' + encodeURIComponent(data.fileData);
        link.click();
      }
    }
    else {
      this.showLoader = true;
      this._CongratulationsService.getCallservice('CongratulationsData', data.quoteItemId).subscribe((response: any) => {
        if (response && response.length) {
          response.map(item => {
            if (item.policyDocumentDownloaded && (item.fileUrl || item.fileData)) {
              this.DownloadPolicy(item);
            } else if (item.partnerPolicyData) {
              let newPdfWindow = window.open("", "Print");
              let content = encodeURIComponent(item.partnerPolicyData);
              let iframeStart = "<\iframe width='100%' height='100%' src='data:application/pdf;base64, ";
              let iframeEnd = "'><\/iframe>";
              newPdfWindow.document.write(iframeStart + content + iframeEnd);
              var link = document.createElement('a');
              link.innerHTML = 'Download PDF file';
              link.download = item.policyNumber + '.pdf';
              link.href = 'data:application/octet-stream;base64,' + encodeURIComponent(item.partnerPolicyData);
              link.click();
            }
          });
        }
        this.showLoader = false;
      });
    }
  }


  /*Payment scenario
  1. Transaction Status->  Y , Customer started with payment and completed policy issuance with PDF
      Sub-stage stamping -> 100% ,Policy issuance - congratulations page with policy number and Policy PDF link
  2. Transaction Status->  Y , Customer completed payment process, navigated to policy issuance page but only has policy number
      Sub-stage stamping -> 100% ,Policy issuance - congratulations page with policy number
  3. Transaction Status->  Y , Payment process completed but policy issuance failed
      Sub-stage stamping -> 90% ,Policy issuance - Payment success - Congratulations page on payment receival
  */

  public Next() {
    this.PostCall(null, 'Proceed');
  }


  // public ExploreMore() {
  //   const exploreMore = this.bflJourney ? this.exploreUrlBFL : this.exploreUrl;
  //   if (!this.bflJourney) {
  //     this._adobe_analytics_service.exploreMoreProducts(this.currentTaskKey, exploreMore);
  //     window.open(exploreMore, '_self');
  //   }
  //   else {
  //     window.open(exploreMore, '_self');
  //   }
  // }

  public ExploreMore(redirectionKey, redirectionValue) {
    const platform = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.platform);
    const redirectionUrl = `inssdk://applaunch?redirection_key=${redirectionKey}&Redirection_value=${redirectionValue}`;
    if (platform.toLowerCase() === CommonConstants.platforms.ios) {
      window.open(redirectionUrl, '_self');
    } else if (platform.toLowerCase() === CommonConstants.platforms.android) {
      window.open(redirectionUrl, '_self');
    } else {
      window.open('https://www.bajajfinserv.in/insurance?utm_source=insurancemarketplace&utm_medium=wallet&utm_campaign=thankyoupage&utm_content=paymentsuccess&utm_term=', '_self');
      const isBFLJourney = this.sharedService.isBFLJourney();
      if (!isBFLJourney) {
        this._adobe_analytics_service.exploreMoreProducts('insInstaPack', this.exploreUrl);
      }
    }
  }

  public getContentFragment() {
    this._planDetailsService.getAemDetails().subscribe((res) => {
      console.log(res);
      this.aemFragmentInfo = res.properties.elements;
    });
  }

  public confirmSelection(event) {
    console.log(event);
  }

  private policyPostCall(data) {
    // this.showLoader = true;
    this.getTaskDetails();
  }

  private getPaymentStatus() {
    if (this.limitCross == false) {
      const requestData = {
        applicationId: this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId),
        quoteId: this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.selectedQuoteId)
      };
      this.paymentStatusService.FetchPaymentStatus(requestData).subscribe((response) => {
        if (!response.errors) {
          this.PaymentData = response.payload;
          if (this.PaymentData) {
            if (this.PaymentData.paymentStatusResponse.paymentStatus.toLowerCase() === 'success') {
              this.PaymentDetails = this.PaymentData.paymentStatusResponse;
            }
          }
        }

      });
    } else {
      this.showLoader = false;
    }
  }

  // Get Task Details
  private getTaskDetails() {
    this.CongratulationScreen = true;
    this.showLoader = true;
    const route = true;
    const data = {
      urlData: {
        applicationId: this.applicationId,
        quoteId: this.quoteId
      },
      payload: null
    };
    setTimeout(() => {
      if (this.limitCross == false) {
        this._CongratulationsService.getCallservice('getPolicy', null, route).subscribe((response: any) => {
          // if(this.principalCode === 'BAGIC') {
          //   this.onGetPolicy(response);
          // } else {
          console.log(response)
          if (response[0] && response[0].policyNumber === null) {
            setTimeout(() => {
              if (this.limitCross == false) {
                this._CongratulationsService.getCallservice('getPolicy', null, route).subscribe((response: any) => {
                  if (response[0] && response[0].policyNumber === null && this.count < 1) {
                    console.log(response)
                    if (this.limitCross == false) {
                      this.policyPost(data);
                    } else {
                      this.showLoader = false;
                    }
                    this.count++;
                  } else {
                    // this.onGetPolicy(response);
                    // this.morethan30 = true;
                    console.log('sd' + this.morethan30)
                    this.showLoader = false;
                    console.log("delay....")
                  }
                });
              } else {
                this.showLoader = false
              }
            }, 20000);
          } else {
            // this.morethan30 = false;
            console.log('sd' + this.morethan30)
            // this.showLoader = false;
            this.onGetPolicy(response);
          }
          // }
        });
      } else {
        this.showLoader = false;
      }
    }, 10000);
  }
  private onGetPolicy(response) {
    if (response && response.length) {
      this.policyDownloadResponseList = response;
      if (this.policyDownloadResponseList[0].policyNumber !== null) {
        this.CongratulationScreen = true;
      }
      this.resultArray = this.policyDownloadResponseList.filter(data =>
        data.policyNumber !== null
      );
      if (this.resultArray && this.resultArray.length > 0) {
      }
      this.policyNullCheck = this.policyDownloadResponseList.every(item => item.policyNumber === null);
    }
    if ((this.policyDownloadResponseList && this.policyDownloadResponseList.length === 0) || (this.policyNullCheck)) {
      this.bothPoliciesNull = true;
    }
    // this.morethan30 = false;
    this.showLoader = false;
    console.log('ssss')
    this.getPaymentStatus();
  }
  // Mark Task As Completed Activiti Call
  private PostCall(data, taskName: string) {
    this.showLoader = true;
    this._CongratulationsService.postCallservice(data, taskName).subscribe((response) => {
      if (!response.errors) {
        if (response.nextTaskKey) {
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.NextTaskKeyOmHR, response.nextTaskKey);
          this._routerService.RouteToNextTask(response.nextTaskKey);
        }
      }
    },
      (error) => {
        this.showLoader = false;
      });
  }
  private policyPost(data) {
    // this.showLoader = true;
    this._CongratulationsService.PostPolicy(data).subscribe((resp) => {
      if (resp === null) {
        if (this.morethan30 !== true && this.limitCross == false) {
          this.getTaskDetails();
          this.showLoader = false;
        }
      } else {
        this.getPaymentStatus();
      }
    },
      (error) => {
        this.getPaymentStatus();
      });
  }
  public googleAnalyticRetry() {

    let partnerName = '';
    let partnerPlanName = '';

    let planVariant = '';

    planVariant = this.summaryData?.quoteItemDetail.find(element => element.quoteItemType === 'PRIMARY').productVariantCode;

    if (!!this.aemFragmentInfo) {
      partnerPlanName =
        this.aemFragmentInfo.productName.variations[this.planCode.toLowerCase() + '_' + planVariant.toLowerCase()].value;

      partnerName =
        this.aemFragmentInfo.principleName.variations[this.planCode.toLowerCase() + '_' + planVariant.toLowerCase()].value;
    }

    this._googleAnalyticsService.pushToDataLayer({
      'event': 'payment_failure',
      'pageType': 'Payment Failure Page',            //E.g. Product Listing Page, Product Detail Page
      'productId': 'HGI',                   //E.g. HGI
      'productName': 'Health Insurance',         //E.g. Health Insurance, Motor Insurance
      'partnerName': partnerName,
      'partnerPlanName': partnerPlanName,
      'premiumAmount': `Rs.${this.formatter.ToCurrency(this.totalGrossPremium.toString())}`,
      'sumInsured': `Rs.${this.formatter.ConvertNumberToAmount(this.selectedSumAssured.toString())}`,   //E.g. 5 Lac, 6 Lac, etc.
      'tenure': `${this.quoteItemDetail.tenure} Year`,
      'section': 'Transaction Failed',         //E.g. Tenure, Insured Member Details, etc.
      'paymentMethod': this.summaryData.paymentDetail.paymentMode,
      'clickText': 'Retry Payment',
      'mobile': this.summaryData.apllicationDetail.mobileNumber,
      'dob': this.summaryData.quoteCriteriaDetail.hGIQuoteCriteria.insuranceDetails.dobProposal,
      'insuringFor': this.summaryData.quoteCriteriaDetail.hGIQuoteCriteria.insuranceDetails.insuringFor,
      'pinCode': this.pinCode,
      'city': this.cityName ? this.cityName : '',
      'appQuoteCriteriaId': this.summaryData.appQuoteCriteriaId,
      'stagePercentage': this.stagePercentage,
      'applicationId': this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.applicationId)
    });
  }
  public navigateAccordingCatogory(banner) {
    const platform = this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.platform);
    const redirectionUrl = `inssdk://applaunch?redirection_key=${banner.redirectionKey}&Redirection_value=${banner.redirectionValue}`;
    if (platform.toLowerCase() === CommonConstants.platforms.ios) {
      window.open(redirectionUrl, '_self');
    } else if (platform.toLowerCase() === CommonConstants.platforms.android) {
      window.open(redirectionUrl, '_self');
    } else {
      window.open(banner.redirectUrl, '_self');
    }
  }
  private setBannersAccordingEnviorment() {
    this._paymentService.getBanners().subscribe((res: any) => {
      this.finalBannerAemArray = res?.widgetComponentDetails[0]?.widgetComponentDetails;

      // Pick only  6 items from array
      this.finalBannerAemArray = this.finalBannerAemArray?.slice(0, 6);
      console.log('length:', this.finalBannerAemArray?.length);

    });
  }


}
